export default  {
  require: {
  },
  controller: 'daySelectController',
  template: require('../views/day.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/components/day.select.component.js